import React, { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";

function Create() {
    const scriptURL = "https://script.google.com/macros/s/AKfycbzQRwBeHHLkubvdCZmI6E31VXRVhPjokdhnQI1ZGnogMfg-TCB4S5MhC4561H6IdEKk/exec";

    const [From, setFrom] = useState("");
    const [To, setTo] = useState("");
    const [Message, setMessage] = useState("");

    const [SubmitButton, setSubmitButton] = useState(false);
    const [LoadingButton, setLoadingButton] = useState(true);
    const [AlertButton, setAlertButton] = useState(true);

    const Opposite = () => {
        setSubmitButton(!SubmitButton);
        setLoadingButton(!LoadingButton);
        setAlertButton(!AlertButton);
        document.getElementById("checkbox").checked = false;
    };

    const Reset = () => {
        setFrom("");
        setTo("");
        setMessage("");
    };

    const form = document.getElementById("confessionForm");
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitButton(!SubmitButton);
        setLoadingButton(!LoadingButton);
        fetch(scriptURL, { method: "POST", body: new FormData(form) })
            .then((response) => {
                Opposite();
                Reset();
                console.log("Success!", response);
            })
            .catch((error) => {
                alert("Whoa! Seem's like there's an error, please try again or refresh the page.");
                console.error("Error!", error.message);
            });
    };

    return (
        <React.Fragment>
            <div className="container w-full mx-auto font-poppins">
                <header className="mx-auto pt-32">
                    <h1 className="text-center text-3xl font-bold text-sky-400">Create Your Confession</h1>
                </header>
                <form
                    onSubmit={handleSubmit}
                    name="confessionForm"
                    id="confessionForm"
                    className="lg:w-6/12 w-11/12 my-10  flex flex-col lg:p-10 px-8 py-4 justify-center items-center mx-auto bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max"
                >
                    <label className="mb-4 block w-full">
                        <span className="text-slate-200">From</span>
                        <input type="text" maxLength={50} name="From" value={From} onChange={(e) => setFrom(e.target.value)} className=" bg-slate-900 text-white border-slate-700  mt-1 block rounded-lg w-full" required placeholder="John" />
                        <span className="block text-xs my-2 text-slate-400">(You can use pseudonym/anonym)</span>
                    </label>
                    <label className="mb-4 block w-full">
                        <span className="text-slate-200">To</span>
                        <input
                            type="text"
                            maxLength={50}
                            name="To"
                            value={To}
                            onChange={(e) => setTo(e.target.value)}
                            className=" bg-slate-900 text-white border-slate-700 form-input mt-1 block rounded-lg w-full"
                            required
                            placeholder="Doe"
                        />
                        <span className="block text-xs my-2 text-slate-400">(You can use pseudonym/anonym)</span>
                    </label>
                    <label className="block mb-4 w-full">
                        <span className="text-slate-200">Message</span>
                        <textarea
                            required
                            name="Message"
                            value={Message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="form-textarea bg-slate-900 text-white border-slate-700  mt-1 block rounded-lg w-full"
                            rows="3"
                            placeholder="Write something..."
                        ></textarea>
                        <span className="block text-xs my-2 animate-pulse text-red-400">(confession with harmful words will not be displayed)</span>
                    </label>
                    <label className="flex mb-4 w-full items-center">
                        <input type="checkbox" id="checkbox" name="Agree" className="rounded-sm form-checkbox" required />
                        <span className="ml-2 text-slate-200">
                            I agree to the{" "}
                            <a href="/privacypolicy" className="underline">
                                privacy policy
                            </a>
                        </span>
                    </label>
                    <div className={AlertButton ? "hidden" : "mb-5 flex lg:p-3 px-4 py-2 text-slate-300 gap-4 justify-center items-center mx-auto bg-slate-800 border-4 border-slate-800 rounded-xl h-max"} role="alert">
                        Thank you, your message has been submitted.
                        <button
                            type="button"
                            onClick={() => {
                                setAlertButton(!AlertButton);
                                setSubmitButton(!SubmitButton);
                                setLoadingButton(!LoadingButton);
                            }}
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                        >
                            <AiFillCloseCircle size={"20px"} />
                        </button>
                    </div>
                    <button
                        type="submit"
                        className={
                            SubmitButton
                                ? "hidden"
                                : " z-10 mb-4 focus:outline-none focus:ring-2 text-white font-semibold h-10 px-4 lg:px-6 rounded-lg flex items-center justify-center mx-auto w-full text-center bg-green-600 hover:bg-green-700"
                        }
                    >
                        Submit
                    </button>
                    <button
                        className={
                            LoadingButton
                                ? "hidden"
                                : "opacity-80 z-10 mb-4 focus:outline-none focus:ring-2 text-white font-semibold h-10 px-4 lg:px-6 rounded-lg flex items-center justify-center mx-auto w-full text-center bg-green-800 hover:bg-green-900"
                        }
                        type="button"
                        disabled
                    >
                        <span className="spinner-border mr-2 spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...
                    </button>
                </form>
            </div>
        </React.Fragment>
    );
}
export default Create;
